import axios from "axios";
import env from "../../constants/apiConst";

/**
 * Caso 1032: consulta la similitud de un nombre (proveedor o importador) con la
 * lista de proveedores ficticios activos. El back retorna en status.data la mejor
 * coincidencia {similarity, name, nit, resolution_number, resolution_date} o null.
 */
export const __CheckFictitiousNameSimilarity = async (token, name) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: { name }
  };

  const res = await axios(env.CHECK_FICTITIOUS_NAME_SIMILARITY, options);
  return res;
};
